import { LocationResponseDto } from '@tiendanube/common';
import {
  VariantCreateRequestApiV2Dto,
  VariantRequestDto,
} from '@tiendanube/common/src/domains/catalog/interfaces';
import { LanguagesType } from 'App/i18n';
import { variantPayloadBuilder } from '../variantPayloadBuilder/variantPayloadBuilder';

export function getCreateVariantsPayload(
  language: LanguagesType,
  variants: VariantRequestDto[] = [],
  locations: LocationResponseDto[],
): VariantCreateRequestApiV2Dto[] {
  const mainLocation = locations.find((location) => location.main);
  if (variants.length === 0) {
    const defaultVariant: VariantCreateRequestApiV2Dto = {
      price: 0,
      inventory_levels: [
        {
          location_id: mainLocation?.id ?? '',
          stock: null,
        },
      ],
      attributes: [],
      weight: 0,
      height: 0,
      width: 0,
      depth: 0,
    };
    return [defaultVariant];
  }

  return variants.map((variant) =>
    variantPayloadBuilder.create(variant, language, mainLocation),
  );
}
